import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  Edit,
  Create,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextInput,
  NumberInput,
  BooleanInput,
  SelectInput,
  ImageField,
  required,
  Toolbar,
  SaveButton,
  DeleteButton as DeleteButtonForm,
} from 'react-admin';

// Liste des produits simplifiée
export const ProductList = (props) => (
  <List
    {...props}
    perPage={25}
    sort={{ field: 'name', order: 'ASC' }}
  >
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      <ImageField source="image" label="Image" />
      <TextField source="name" label="Nom" />
      <TextField source="category" label="Catégorie" />
      <NumberField source="price" label="Prix (€)" />
      <TextField source="unit" label="Unité" />
      <NumberField source="stock" label="Stock" />
      <BooleanField source="featured" label="Vedette" />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

// Toolbar personnalisée pour l'édition
const ProductEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <DeleteButtonForm />
  </Toolbar>
);

// Édition d'un produit
export const ProductEdit = (props) => (
  <Edit {...props} title="Modifier le produit">
    <SimpleForm toolbar={<ProductEditToolbar />}>
      <TextInput source="name" label="Nom" validate={[required()]} fullWidth />
      <SelectInput
        source="category"
        label="Catégorie"
        choices={[
          { id: 'Bœuf', name: 'Bœuf' },
          { id: 'Porc', name: 'Porc' },
          { id: 'Agneau', name: 'Agneau' },
          { id: 'Veau', name: 'Veau' },
          { id: 'Volaille', name: 'Volaille' },
          { id: 'Charcuterie', name: 'Charcuterie' },
        ]}
        validate={[required()]}
      />
      <NumberInput source="price" label="Prix (€)" validate={[required()]} />
      <TextInput source="unit" label="Unité" validate={[required()]} />
      <NumberInput source="stock" label="Stock" validate={[required()]} />
      <TextInput source="image" label="URL de l'image" fullWidth />
      <TextInput source="description" label="Description" multiline rows={4} fullWidth />
      <BooleanInput source="featured" label="Produit vedette" />
    </SimpleForm>
  </Edit>
);

// Création d'un produit
export const ProductCreate = (props) => (
  <Create {...props} title="Créer un nouveau produit">
    <SimpleForm>
      <TextInput source="name" label="Nom" validate={[required()]} fullWidth />
      <SelectInput
        source="category"
        label="Catégorie"
        choices={[
          { id: 'Bœuf', name: 'Bœuf' },
          { id: 'Porc', name: 'Porc' },
          { id: 'Agneau', name: 'Agneau' },
          { id: 'Veau', name: 'Veau' },
          { id: 'Volaille', name: 'Volaille' },
          { id: 'Charcuterie', name: 'Charcuterie' },
        ]}
        validate={[required()]}
      />
      <NumberInput source="price" label="Prix (€)" validate={[required()]} />
      <TextInput source="unit" label="Unité" validate={[required()]} />
      <NumberInput source="stock" label="Stock" validate={[required()]} />
      <TextInput source="image" label="URL de l'image" fullWidth />
      <TextInput source="description" label="Description" multiline rows={4} fullWidth />
      <BooleanInput source="featured" label="Produit vedette" />
    </SimpleForm>
  </Create>
);

// Affichage détaillé d'un produit
export const ProductShow = (props) => (
  <Show {...props} title="Détails du produit">
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <ImageField source="image" label="Image" />
      <TextField source="name" label="Nom" />
      <TextField source="category" label="Catégorie" />
      <NumberField source="price" label="Prix (€)" />
      <TextField source="unit" label="Unité" />
      <NumberField source="stock" label="Stock" />
      <TextField source="description" label="Description" />
      <BooleanField source="featured" label="Produit vedette" />
    </SimpleShowLayout>
  </Show>
);